// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { AppShell, Box } from '@mantine/core';

import { useIsMobile } from 'hooks/useIsMobile';

const MobileLayout = ({ children }: { children: ReactNode }) => (
  <AppShell.Main
    display="flex"
    // Fixed viewport height (Mantine already pads the top for the fixed header) with
    // clipped overflow, so mobile pages become the scroll boundary and manage their own
    // internal scrolling instead of scrolling the whole page.
    h="100dvh"
    style={{ flexDirection: 'column', overflow: 'hidden' }}
  >
    {children}
  </AppShell.Main>
);

const DesktopLayout = ({ children }: { children: ReactNode }) => (
  <AppShell.Main display="flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
    <Box
      h="100dvh"
      pos="relative"
      p="sm"
      maw="100%"
      style={{
        gap: 0,
        position: 'relative',
        flexGrow: 1,
      }}
    >
      {children}
    </Box>
  </AppShell.Main>
);

export const AppMain = ({ children }: { children: ReactNode }) =>
  useIsMobile() ? <MobileLayout>{children}</MobileLayout> : <DesktopLayout>{children}</DesktopLayout>;
